import React, { useState } from "react";
import CustomTextField from "../../../common/InputField/Input";
import UploadFile from "../BEHotelDetails/UploadId";
import beImagePlaceHolder from "../../../../assets/images/svgs/beImagePlaceHolder.svg";
import { message } from "antd";
import { isFileSizeValid } from "../../utils";
import { uploadFiles } from "../../../../services/scanUpload";
import Preview from "./Preview";
import { TranslateText } from "../../../../utils/translation";

const Index = ({ localHotelDetailsState, setLocalHotelDetailsState }) => {
  const [localplaceInformation, setLocalPlaceInformation] = useState({
    description: "",
    name: "",
    distance: "",
    urls: [],
    type: "Local Attraction",
  });

  const [currentSelectedLocation, setCurrentSelectedLocation] =
    useState("Local Attraction");

  const handleImageBeforeUpload = async (file, fileSize) => {
    const fileSizeInKb = fileSize * 1000;

    if (
      !isFileSizeValid(
        file,
        fileSize,
        `File size must be smaller than ${fileSizeInKb} kb`
      )
    ) {
      message.error(`File size must be lesser than ${fileSizeInKb} kb`);
      return false;
    } else return true;
  };

  const handleUpload = async (item, title) => {
    const file = item.file;
    const data = new FormData();
    data.append("file", file);

    let uploadedFile = await uploadFiles(data);

    if (uploadedFile !== null) {
      setLocalPlaceInformation({
        ...localplaceInformation,
        urls: [uploadedFile], // Using computed property name for dynamic key
      });

      message.success(`Image Uploaded `);
    }
  };

  const handleSave = () => {
    if (!localplaceInformation?.name) {
      message.info("Please enter Name of the place");
      return;
    }
    if (!localplaceInformation?.distance) {
      message.info("Please enter Distance from hotel");
      return;
    }

    setLocalHotelDetailsState((prevState) => ({
      ...prevState,
      nearbyAttractions: [
        ...(Array.isArray(prevState?.nearbyAttractions)
          ? prevState.nearbyAttractions
          : []),
        localplaceInformation,
      ],
    }));

    setLocalPlaceInformation({
      description: "",
      name: "",
      distance: "",
      urls: [],
      type: "",
    });

    message.success("Place Saved successfully");
  };

  return (
    <div className="mb-[10rem] flex flex-col gap-[34px]">
      <div className="flex justify-between items-center">
        <div
          className="w-[65%] font-body font-[400] text-[20px] leading-[30.24px] 
        text-fg"
        >
          
          <TranslateText
                      textKey={"select_place_category"}
                      namespace="profile"
                    /> 
        </div>

        <div
          className=" font-body font-[500] text-[16px] leading-[24px] text-primary justify-end cursor-pointer"
          onClick={handleSave}
        >
          
          <TranslateText
                      textKey={"save_and_add_new"}
                      namespace="profile"
                    /> 
        </div>
      </div>

      <div className="flex gap-[16px] items-center flex-wrap">
        {[
          "Local Attraction",
          "Top sights",
          "Airport",
          "Restaurant",
          "Public Transport",
          "Railway Station",
          "Hospital",
          "Super Market",
          "Malls",
        ].map((category) => {
          return (
            <div
              key={category}
              className={` ${
                currentSelectedLocation === category
                  ? "text-primary border-primary border-[1px] bg-surface"
                  : "bg-surface-page text-fg border-[1px] border-brand-border-muted"
              }   px-[12px] py-[7px] font-body font-[400] text-[14px] leading-[18px]  cursor-pointer  rounded-[18px] whitespace-nowrap`}
              onClick={() => {
                setCurrentSelectedLocation(category);
                setLocalPlaceInformation({
                  description: "",
                  name: "",
                  distance: "",
                  urls: [],
                  type: category,
                });
              }}
            >
              {category}
            </div>
          );
        })}
      </div>

      <div className="flex flex-col gap-[34px]">
        <div
          className="w-[65%] font-body font-[400] text-[20px] leading-[30.24px] 
        text-fg"
        >
          
          <TranslateText
                      textKey={"places_information"}
                      namespace="profile"
                    /> 
        </div>

        <div className="flex justify-between gap-[24px] items-start h-[190px]">
          <div className="leftSection w-[80%]  flex flex-col gap-[20px]">
            <CustomTextField
              label="Place name &nbsp;"
              isManadatory={false}
              value={localplaceInformation?.name}
              onChange={(value) =>
                setLocalPlaceInformation({
                  ...localplaceInformation,
                  name: value,
                })
              }
              type="text"
              inputPadding={true}
              inputPaddingValue="8px"
              labelFontSize="14px"
            />
            <CustomTextField
              label="Distance from hotel ex- 1.2 km"
              isManadatory={false}
              value={localplaceInformation?.distance}
              onChange={(value) =>
                setLocalPlaceInformation({
                  ...localplaceInformation,
                  distance: value,
                })
              }
              type="text"
              inputPadding={true}
              inputPaddingValue="8px"
              labelFontSize="14px"
            />{" "}
            <CustomTextField
              label="Description"
              isManadatory={false}
              value={localplaceInformation?.description}
              onChange={(value) =>
                setLocalPlaceInformation({
                  ...localplaceInformation,
                  description: value,
                })
              }
              type="text"
              inputPadding={true}
              inputPaddingValue="8px"
              labelFontSize="14px"
            />
          </div>

          <div className="rightSection w-[190px] h-[100%]">
            {!localplaceInformation?.urls?.[0] ? (
              <div className="w-[100%] h-[100%] bg-surface-page border-[1px] border-brand-border-muted flex flex-col justify-center items-center   rounded-[8px]">
                <div className="w-[32px] h-[32px]">
                  <img
                    src={beImagePlaceHolder}
                    className="w-[100%] h-[100%]"
                    alt=""
                  />
                </div>
                <div className="font-body font-[400] text-[14px] leading-[21px] text-fg-placeholder ">
                <TranslateText
                      textKey={"drag_and_drop_your_image"}
                      namespace="profile"
                    /> 
                  {" "}
                </div>
                <UploadFile
                  handleImageBeforeUpload={handleImageBeforeUpload}
                  handleUpload={handleUpload}
                  fileSize={10}
                >
                  <div className="font-body font-[400] text-[14px] leading-[21px] text-primary cursor-pointer">
                  <TranslateText
                      textKey={"or_choose"}
                      namespace="profile"
                    />  
                  </div>
                </UploadFile>
              </div>
            ) : (
              <img
                src={localplaceInformation?.urls?.[0]}
                alt="rect"
                id="viewer"
                className=" w-[100%] h-[100%] "
              />
            )}
          </div>
        </div>
      </div>

      <div className="font-body font-[500] text-[24px] leading-[30.24px] text-fg bg-brand-border-muted py-[8px] flex justify-center items-center w-[100%] mt-[64px] mb-[24px]">
         
        <TranslateText
                      textKey={"preview"}
                      namespace="profile"
                    />  
      </div>

      <div className="previewSection">
        <Preview localHotelDetailsState={localHotelDetailsState} />
      </div>
    </div>
  );
};

export default Index;
